export default "__VITE_ASSET__743c12bd__"